exports.supportedLanguages = {
  tr: 'Türkçe',
  en: 'English',
  de: 'Deutsch',
  it: 'Italiano',
  fr: 'Français',
  ru: 'Русский',
};
